





































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import VToolbar from "../../common/components/VToolbar.vue";
import InvoiceService from "@/usecases/orders/invoice-service";
import EstimateService from "../../../usecases/orders/estimate-service";
import { MoveEstimateEvent } from "../presenters/move-event";
import EstimateState from "@/usecases/accounting/estimate-status";
import Status from "@/usecases/orders/estimate-status";
import Estimate from "../../../usecases/orders/estimate";
import VIconEdit from "../../../components/icons/VIconEdit.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import VIconEstimate from "../../../components/icons/VIconEstimate.vue";
import EstimateApi from "../../../api/orders/estimate-api";
import PrintApi from "../../../api/orders/print-api";
import { client } from "@/api/request";
import InvoiceApi from "../../../api/orders/invoice-api";
import VSearchBar from "../../../components/VSearchBar.vue";
import BillingRuleApi from "@/orders/api/billing-rule-api";
import { getUserAriseServices, ServiceArise } from "@/api/service-api";
import ProjectOrderTabs from "@/components/ProjectOrderTabs.vue";
import EstimateStatus from "../components/EstimateStatus.vue";
import { cloneDeep } from "lodash";
import EstimateContractDateModal from "@/ui/order/components/EstimateContractDateModal.vue";
import LoadingButton from "@/components/LoadingButton.vue";

const billingRuleApi = new BillingRuleApi(client);
const estimateApi = new EstimateApi(client);
const printApi = new PrintApi(client);
const service = new EstimateService(estimateApi);
const invoiceApi = new InvoiceApi(client);
const estimateService = new EstimateService(estimateApi);
const invoiceService = new InvoiceService(invoiceApi, billingRuleApi);

@Component({
  components: {
    LoadingButton,
    EstimateContractDateModal,
    ProjectOrderTabs,
    EstimateStatus,
    VToolbar,
    VSearchBar,
    VIconEdit,
    VIconPrint,
    VIconEstimate
  }
})
export default class EstimateListPage extends Vue {
  @Prop() projectId?: string;
  @Prop({ type: Boolean }) edition!: boolean;
  estimateItems: Estimate[] = [];
  estimateItemsBeforeDragged: Estimate[] = [];
  estimateItemsInit: Estimate[] = [];
  estimateIdsUpdated: Set<number> = new Set();
  estimateIdsPrinting: number[] = [];
  resetLoadInfinite = 0;
  estimateId: string = "";
  contractDate: string = "";

  roles: ServiceArise[] = [];

  searchOptions = {
    projectName: ""
  };

  editing: boolean = false;
  dragMode = false;
  status = "";
  readonly Status = Status;

  async create() {
    const id = await estimateApi.create(Number(this.projectId));
    this.edit(id);
  }

  edit(id: number) {
    this.$router.push({
      name: "order-estimate-edit",
      params: {
        id: String(id)
      }
    });
  }

  search(projectName: string) {
    this.searchOptions = { projectName };
    this.initServiceRoles();
    this.initEstimateList(this.searchOptions);
  }

  async duplicate(id: number) {
    const newEstimateId = await service.duplicate(id);
    this.edit(newEstimateId);
  }

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (this.estimateIdsPrinting.length > 0) {
      alert(
        "現在他の見積書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
      return;
    }

    this.estimateIdsPrinting.push(id);
    try {
      const url = await printApi.getEstimatePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      window.open(url, "見積書印刷");
    } finally {
      this.estimateIdsPrinting = this.estimateIdsPrinting.filter(
        estimateId => estimateId !== id
      );
    }
  }

  purchase(id: number) {
    this.$router.push({
      name: "estimate-purchase",
      params: {
        estimateId: String(id)
      }
    });
  }

  // estimateを元にinvoiceを保存して編集ページに移動する
  async invoice(id: number) {
    const estimate = await service.find(id);
    if (!estimate) return;

    const invoiceId = await invoiceService.invoice(estimate);
    await this.$router.push({
      name: "order-invoice-edit",
      params: {
        id: String(invoiceId)
      }
    });
  }

  // Save the invoice not based on the estimate and move to the edit page
  async createInvoiceNotBasedOnEstimate(estimateId: number) {
    const estimate = await service.find(estimateId);
    if (!estimate) return;

    const invoiceId = await invoiceService.invoiceNotBasedOnRowsOfEstimate(
      estimate
    );
    await this.$router.push({
      name: "order-invoice-edit",
      params: {
        id: String(invoiceId)
      }
    });
  }

  addActualResult(estimateId: number) {
    this.$router.push({
      name: "order-estimate-actual",
      params: {
        id: String(estimateId)
      }
    });
  }

  async changeStatus(id: string, status: string, contractDate: string = "") {
    const estimateSelected = this.estimateItemsInit.find(
      estimate => estimate.id.toString() === id
    );
    let hasChild = estimateSelected !== undefined;
    await estimateService.changeStatus(id, status, hasChild, contractDate);
    await this.$store.dispatch("getStatusProject");
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
    if (status === Status.Success) {
      await this.$store.dispatch("setContractDateProject", contractDate);
      this.contractDate = contractDate;
    }
    await this.initServiceRoles();
    await this.initEstimateList(this.searchOptions);
  }

  async handleChangeStatus(id: string, status: string) {
    if (status === Status.Success) {
      this.estimateId = id;
      (this.$refs.modalSetContractDate as any).show();
      return;
    }
    await this.changeStatus(id, status);
  }

  protected created() {
    this.initServiceRoles();
    this.initContractDateDefault();
    // this.initEstimateList(); // 初回も自動ロードされる
  }

  private async initServiceRoles() {
    this.roles = await getUserAriseServices();
  }

  private initContractDateDefault() {
    if (this.$store.state.project && this.$store.state.project.contractDate) {
      this.contractDate = this.$store.state.project.contractDate;
    }
  }

  currentOptions(currentLength: number, options?: { projectName: string }) {
    return {
      ...options,
      projectId: this.projectId,
      estimateCount: currentLength,
      estimateTree: 1
    };
  }

  async getEstimateList30(options?: any) {
    // 現在の件数は、内容を表示している estimateItems から直接取得
    const new_options = this.currentOptions(this.estimateItems.length, options);
    return await estimateApi.findAll(new_options);
  }

  // 初期化を区別
  private async initEstimateList(options?: { projectName: string }) {
    this.resetLoadInfinite += 1; // リロードリセット
    const new_options = this.currentOptions(0, options); // 取得開始を0件に

    this.estimateItems = await estimateApi.findAll(new_options);
  }

  /**
   * 最下部 自動リロード
   */
  // TODO: 表示条件変更時に、表示完了の際に 検索結果はありません が出てしまう事がある
  async loadInfinite($state: any) {
    const loadedEstimateItems: Estimate[] = await this.getEstimateList30(
      this.searchOptions
    );

    // 表示するデータがあれば表示、なければ終了
    if (loadedEstimateItems.length) {
      if (this.estimateItems.length == 0) {
        this.estimateItems = loadedEstimateItems;
      } else {
        this.estimateItems = this.estimateItems.concat(loadedEstimateItems);
      }
      this.estimateItemsInit = cloneDeep(this.estimateItems);

      $state.loaded();
    } else {
      $state.complete();
    }
  }

  move(e: MoveEstimateEvent<Estimate>) {
    // Disable dragging and dropping into estimates with a success status
    const parentElement = e.to.closest(
      `[data-status=${EstimateState.Success}]`
    );
    if (parentElement) {
      return false;
    }
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;

    const children = e.draggedContext.element.children.length;
    return !(from === "parents" && to === "children" && children > 0);
  }

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  dragstart() {
    this.estimateItemsBeforeDragged = cloneDeep(this.estimateItems);
    this.editing = true;
  }

  dragend(e: any) {
    this.editing = false;
    const estimateId: number = Number(e.item.dataset.id);
    this.updateEstimateUpdated(estimateId);
  }

  async updateEstimateUpdated(id: number) {
    await this.calculateTotal(id);
    this.setEstimateIdsUpdating(this.estimateItemsInit, this.estimateItems);
  }

  private setEstimateIdsUpdating(init: Estimate[], afterDragged: Estimate[]) {
    const updatedIds: Set<number> = new Set();

    const findDifferences = (
      initItem: Estimate,
      draggedItem: Estimate
    ): boolean => {
      // Compare if the number of children is different
      if (initItem.children.length !== draggedItem.children.length) {
        return true;
      }
      // Compare each child's id
      for (let i = 0; i < initItem.children.length; i++) {
        if (initItem.children[i].id !== draggedItem.children[i].id) {
          return true;
        }
      }
      return false;
    };

    // Create a map of the dragged items for quick lookup by id
    const draggedMap = new Map(afterDragged.map(item => [item.id, item]));
    const initMap = new Map(init.map(item => [item.id, item]));

    for (const initItem of init) {
      const draggedItem = draggedMap.get(initItem.id);
      // If there's no corresponding item or if the children structure is different, mark it as updated
      if (draggedItem && findDifferences(initItem, draggedItem)) {
        updatedIds.add(initItem.id);
      }
    }

    for (const draggedItem of afterDragged) {
      const initItem = initMap.get(draggedItem.id);
      // If the dragged item has become a top-level item but was previously a child, mark it as updated
      if (!initItem) {
        updatedIds.add(draggedItem.id);
      }
    }

    this.estimateIdsUpdated = updatedIds;
  }

  async calculateTotal(id: number) {
    let estimateDragged = this.estimateItemsBeforeDragged.find(
      estimate => estimate.id === id
    );
    //level 1 -> level 2
    if (estimateDragged) {
      let newEsParent = this.estimateItems.find(
        estimate =>
          estimate.children.length > 0 &&
          estimate.children.some(child => child.id === id)
      );
      if (newEsParent) {
        // add child
        this.estimateItems.forEach(estimate => {
          if (
            newEsParent &&
            estimateDragged &&
            estimate.id === newEsParent.id
          ) {
            service.addChild(estimate, estimateDragged);
          }
        });
      }
    }
    //level 2 -> level 1, level 2 -> level 2
    if (!estimateDragged) {
      let oldEsParent: Estimate;
      for (let i = 0; i < this.estimateItemsBeforeDragged.length; i++) {
        let estimate = this.estimateItemsBeforeDragged[i];
        if (estimate.children.length > 0) {
          let foundChild = estimate.children.find(child => child.id === id);
          if (foundChild) {
            estimateDragged = foundChild;
            oldEsParent = estimate;
            break;
          }
        }
      }

      if (estimateDragged) {
        // remove child
        this.estimateItems.forEach(estimate => {
          if (estimateDragged && estimate.id === oldEsParent.id) {
            service.removeChild(estimate, estimateDragged);
          }
        });

        let newEsParent = this.estimateItems.find(
          estimate =>
            estimate.children.length > 0 &&
            estimate.children.some(child => child.id === id)
        );

        if (newEsParent) {
          // add child
          this.estimateItems.forEach(estimate => {
            if (
              newEsParent &&
              estimateDragged &&
              estimate.id === newEsParent.id
            ) {
              service.addChild(estimate, estimateDragged);
            }
          });
        }
      }
    }
  }

  switchDragMode() {
    this.dragMode = true;
  }

  isDraggable(estimateParent: Estimate): boolean {
    return this.dragMode && estimateParent.status !== EstimateState.Success;
  }

  async save() {
    this.status = "progressing";
    const estimates = this.estimateItems.filter(estimate =>
      this.estimateIdsUpdated.has(estimate.id)
    );
    if (estimates.length <= 0) {
      this.estimateItemsInit = cloneDeep(this.estimateItems);
      this.estimateIdsUpdated.clear();
      this.dragMode = false;
      this.status = "";
      return;
    }
    try {
      await service.saveEstimates(estimates);
      await this.initServiceRoles();
      await this.initEstimateList(this.searchOptions);
      await this.$store.dispatch("setProjectEstimateExpenseSummary");
      this.estimateItemsInit = cloneDeep(this.estimateItems);
      this.estimateIdsUpdated.clear();
      this.dragMode = false;
      alert("保存に成功しました。");
    } catch (error) {
      alert("保存に失敗しました。");
    } finally {
      this.status = "";
    }
  }

  showLoading(id: number) {
    return this.estimateIdsPrinting.includes(id);
  }

  disableDownLevel(item: Estimate, index: number): boolean {
    const isFirstItemInLayer = index === 0;
    const hasChild = item.children.length > 0;
    return isFirstItemInLayer || hasChild || !this.dragMode;
  }

  upLevel(oldParent: Estimate, newParent: Estimate[], item: Estimate) {
    oldParent.children.splice(oldParent.children.indexOf(item), 1);
    newParent.splice(newParent.indexOf(oldParent) + 1, 0, item);
    // re-calculate estimate oldParent
    service.removeChild(oldParent, item);
    this.setEstimateIdsUpdating(this.estimateItemsInit, this.estimateItems);
  }

  downLevel(oldParent: Estimate[], newParent: Estimate, item: Estimate) {
    oldParent.splice(oldParent.indexOf(item), 1);
    newParent.children.splice(newParent.children.length, 0, item);
    // re-calculate estimate newParent
    service.addChild(newParent, item);
    this.setEstimateIdsUpdating(this.estimateItemsInit, this.estimateItems);
  }
}
